import { Authority } from '../../../shared/enums/authority.enum';
import { FeatureIdentifier } from '../../../shared/enums/feature-identifier.enum';
import { ManagerByPlaceType } from '../../../shared/enums/manager-by-place.enum';
import { NotificationType } from '../../../shared/enums/notification-type.enum';
import { Status } from '../../../shared/enums/status.enum';
import { StoreRegisterType } from '../../../shared/enums/store-register-type.enum';
import { SubscriptionStatus } from '../../../shared/enums/subscription-status.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Country } from '../../../shared/models/country.model';
import { FeatureInTest } from '../../../shared/models/feature-in-test.model';
import { Photo } from '../../../shared/models/photo.model';
import { ShortLink } from '../../../shared/models/shortlink.model';
import { Invoice } from '../../../shared/models/subscription.model';
import { Translation } from '../../../shared/models/translation.model';
import { Place } from '../../place/models/place.model';
import { Wallet } from '../../wallet/models/wallet.model';
import { BusinessType } from '../enums/business-type.enum';
import { OpenStatus } from '../enums/open-status.enum';
import { PaymentProviderStatus } from '../enums/payment-provider-status.enum';

export class Store {
  id: number;
  storeUuid: string;
  establishmentName: string;
  tradeName: string;
  ddiPhone: string;
  establishmentPhone: string;
  cnpj: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  complement: string;
  landmark: string;
  contactName: string;
  cpf: string;
  howKnow: string;
  contactEmail: string;
  ddiContactMobilePhone: string;
  contactMobilePhone: string;
  description: string;
  coverImage: Photo;
  logoImage: Photo;
  averageRating: number;
  numberReviews: number;
  businessType: BusinessType;
  allowPayLater: boolean;
  status: Status;
  openingStatus: OpenStatus;
  lat?: number;
  lon?: number;
  // changeGeolocation: boolean;
  allowOnlinePayment: boolean; // oferecer opção para pagamento online
  optionForHere: boolean; // oferece opção para comer no local
  offerPickup: boolean; // oferece opção para retirada
  offerDriveIn: boolean; // oferece opção para retirada
  acceptDelivery: boolean;
  allowOrderReservation: boolean;
  allowOnlyOrderReservation: boolean;
  place: Place;
  shortLink: ShortLink;
  nextClosingDate: number;
  nextOpeningDate: number;
  authority: Authority;
  paymentCustomerId: string;
  minimumDeliveryPrice: number;
  featureIdentifiers: Array<FeatureIdentifier>;
  subscriptionStatus: SubscriptionStatus;
  featureInTest: Array<FeatureInTest>;
  invoiceDetails: Invoice | string;
  paymentProviderStatus: PaymentProviderStatus;
  notificationParams: NotificationType[];
  ddiWhatsappPhone: string;
  whatsappPhone: string;

  // código cupom de desconto
  coupon: string;

  // Filial
  validateCnpj: boolean;
  branch: boolean;
  preRegistration: boolean;
  storeReference: number;
  userRegistration: number;

  // Cadastro place
  placeId?: number;
  placeManagementsType: ManagerByPlaceType;

  // aux view
  fullAddress: string;
  descriptionTranslations: Translation;
  wallet: Wallet;

  ddiCountryCode: Country;
  phoneMask: any;

  ddiContactCountryCode: Country;
  contactPhoneMask: any;

  ddiWhatsAppCountryCode: Country;
  whatsAppPhoneMask: any;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, Status);
    } else if (this.id && this.status == null) {
      this.status = Status.UNKNOWN;
    }
    if (!this.contactEmail) {
      this.contactEmail = '';
    }
    if (this.number == 'null') {
      this.number = null;
    }
    if (this.authority != null && this.authority['code'] == null) {
      this.authority = UtilHelper.getEnumByCod(this.authority, Authority);
    }
    this.fullAddress = this.getFullFormattedAddress();

    if (obj.invoiceDetails && typeof obj.invoiceDetails == 'string') {
      this.invoiceDetails = JSON.parse(obj.invoiceDetails);
    }
    this.ddiPhone = UtilHelper.unmask(this.ddiPhone || '55');
    this.ddiContactMobilePhone = UtilHelper.unmask(this.ddiContactMobilePhone || '55');
    this.ddiWhatsappPhone = UtilHelper.unmask(this.ddiWhatsappPhone || '55');
  }

  getFullFormattedAddress(): string {
    let address: string = '';
    if (this.street) {
      address += this.street;
    }
    if (this.number) {
      address += ', ' + (this.number == '0' ? 'S/N' : this.number);
    }
    if (this.complement) {
      address += ', ' + this.complement;
    }
    if (this.neighborhood) {
      address += ' - ' + this.neighborhood;
    }
    if (this.city) {
      address += ', ' + this.city;
    }
    if (this.state) {
      address += ' - ' + this.state;
    }
    return address;
  }

  getStreetFormattedAddress(): string {
    let address: string = '';
    if (this.street) {
      address += this.street;
    }
    if (this.number) {
      address += ', ' + this.number;
    }
    return address;
  }

  // Ap 2 - Centro, Curitiba - PR
  getComplementFormattedAddress(): string {
    let address: string = '';
    if (this.complement) {
      address += this.complement;
    }
    if (this.neighborhood) {
      address += (address ? ' - ' : ' ') + this.neighborhood;
    }
    if (this.city) {
      address += ', ' + this.city;
    }
    if (this.state) {
      address += ' - ' + this.state;
    }
    return address;
  }

  isOnlyMenu(): boolean {
    return !this.acceptDelivery && !this.offerPickup && !this.optionForHere && !this.offerDriveIn;
  }

  isDataIncomplete(): boolean {
    return !this.establishmentName || !this.cnpj || !this.zipCode;
  }

  toJsonNewStore(type: StoreRegisterType): any {
    let data: any = {
      establishmentName: UtilHelper.removeLinksAndInvalidKeywords(this.establishmentName),
      tradeName: UtilHelper.removeLinksAndInvalidKeywords(this.tradeName),
      ddiPhone: this.ddiPhone,
      establishmentPhone: UtilHelper.unmask(this.establishmentPhone),
      cnpj: UtilHelper.unmask(this.cnpj),
      contactName: this.contactName,
      cpf: UtilHelper.unmask(this.cpf),
      contactEmail: this.contactEmail,
      ddiContactMobilePhone: this.ddiContactMobilePhone,
      contactMobilePhone: UtilHelper.unmask(this.contactMobilePhone),
      zipCode: UtilHelper.unmask(this.zipCode),
      state: this.state,
      city: this.city,
      neighborhood: this.neighborhood,
      street: this.street,
      number: this.number,
      complement: this.complement,
      landmark: this.landmark,
    };
    if (type === StoreRegisterType.BRANCH) {
      data.validateCnpj = false;
      data.branch = true;
      data.preRegistration = true;
      data.storeReference = this.storeReference;
      data.userRegistration = this.userRegistration;
    } else if (type === StoreRegisterType.PLACE_STORE) {
      data.placeId = this.placeId;
    }
    return data;
  }

  showAddress(): boolean {
    // Espetinhos Londrina - Dark kitchen
    return this.storeUuid != '651ffe8c-5329-11ef-bdf9-029e72b0772d';
  }
}

/**
 * Usado no form para a seção dos campos de dados gerais
 */
export class StoreDataForm {
  id: number;
  establishmentName: string;
  tradeName: string;
  ddiPhone: string;
  establishmentPhone: string;
  cnpj: string;
  contactName: string;
  cpf: string;
  contactEmail: string;
  ddiContactMobilePhone: string;
  contactMobilePhone: string;
  ddiWhatsappPhone: string;
  whatsappPhone: string;

  // Aux view
  ddiCountryCode: Country;
  phoneMask: any;

  ddiContactCountryCode: Country;
  contactPhoneMask: any;

  ddiWhatsAppCountryCode: Country;
  whatsAppPhoneMask: any;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  toJson(): any {
    return {
      id: this.id,
      establishmentName: UtilHelper.removeLinksAndInvalidKeywords(this.establishmentName),
      tradeName: UtilHelper.removeLinksAndInvalidKeywords(this.tradeName),
      ddiPhone: this.ddiPhone,
      establishmentPhone: UtilHelper.unmask(this.establishmentPhone),
      cnpj: UtilHelper.unmask(this.cnpj),
      contactName: this.contactName,
      cpf: UtilHelper.unmask(this.cpf),
      contactEmail: this.contactEmail,
      ddiContactMobilePhone: this.ddiContactMobilePhone,
      contactMobilePhone: UtilHelper.unmask(this.contactMobilePhone),
    };
  }
}

/**
 * Usado no form para a seção dos campos de endereço
 */
export class StoreAddressForm {
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  complement: string;
  landmark: string;
  lat: number;
  lon: number;

  constructor(store?: Store) {
    if (store) {
      this.zipCode = store.zipCode;
      this.state = store.state;
      this.city = store.city;
      this.neighborhood = store.neighborhood;
      this.street = store.street;
      this.number = store.number;
      this.complement = store.complement;
      this.lat = store.lat;
      this.lon = store.lat;
      this.landmark = store.landmark;
    }
  }

  getFullFormattedAddress(): string {
    let address: string = '';
    if (this.street) {
      address += this.street;
    }
    if (this.number) {
      address += ', ' + this.number;
    }
    if (this.complement) {
      address += ', ' + this.complement;
    }
    if (this.neighborhood) {
      address += ' - ' + this.neighborhood;
    }
    if (this.city) {
      address += ', ' + this.city;
    }
    if (this.state) {
      address += ' - ' + this.state;
    }
    return address;
  }

  getStreetFormattedAddress(): string {
    let address: string = '';
    if (this.street) {
      address += this.street;
    }
    if (this.number) {
      address += ', ' + this.number;
    }
    return address;
  }

  // Ap 2 - Centro, Curitiba - PR
  getComplementFormattedAddress(): string {
    let address: string = '';
    if (this.complement) {
      address += this.complement;
    }
    if (this.neighborhood) {
      address += (address ? ' - ' : ' ') + this.neighborhood;
    }
    if (this.city) {
      address += ', ' + this.city;
    }
    if (this.state) {
      address += ' - ' + this.state;
    }
    return address;
  }

  toJson(): any {
    return {
      zipCode: UtilHelper.unmask(this.zipCode),
      state: this.state,
      city: this.city,
      neighborhood: this.neighborhood,
      street: this.street,
      number: this.number,
      complement: this.complement || '-',
      landmark: this.landmark || '-',
      lat: this.lat,
      lon: this.lon,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/store/models/store.model.ts